import { Component, Input, OnInit } from '@angular/core'
import { ComponentWithCopy } from '../../intefaces/interfaces'
import { ButtonModule } from 'primeng/button';
import { HeadlineLarge } from '../../components/typography/headline-large/headline-large';
import { BodyLarge } from '../../components/typography/body-large/body-large';

@Component({
	selector: 'app-customer-reviews',
	imports: [ButtonModule, HeadlineLarge, BodyLarge],
	templateUrl: './customer-reviews.html',
	styleUrl: './customer-reviews.css',
})
export class CustomerReviews implements OnInit {
	@Input() content!: ComponentWithCopy

	testimonials!: any[]

  ngOnInit(): void {
    this.testimonials = this.content.copy
  }


}
